
<nav>
  <a class="button" routerLink="/" routerLinkActive="activebutton" [routerLinkActiveOptions]= "{exact: true}">Frontpage</a> |
  <a class="button" routerLink="/bulldog" routerLinkActive="activebutton">Bulldog</a> |
  <a class="button" href="/terms">Terms</a> |
  <a class="button" routerLink="/about-us" routerLinkActive="activebutton">About us</a>
</nav>
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content above * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * End of Placeholder * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->



<router-outlet></router-outlet>